import { render, staticRenderFns } from "./Livraison.vue?vue&type=template&id=23359c20&"
import script from "./Livraison.vue?vue&type=script&lang=js&"
export * from "./Livraison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports